import axiosApiClient from '..';
import { handleError, throwErrorIfWrongStatus } from './utils';

const BASE_URL = 'auth/t';
const GET_USER_INFO_RETRY_COUNT = 5;
const GET_USER_INFO_RETRY_DELAYS_MS = [300, 600, 1000, 1500, 2000];

const wait = delay => new Promise(resolve => setTimeout(resolve, delay));

const isRetryableConnectionError = err => {
  const errorCode = err?.code || err?.cause?.code;
  const errorMessage = `${err?.message || ''} ${err?.cause?.message || ''}`;

  return (
    !err?.response &&
    (errorCode === 'ERR_NETWORK' ||
      errorMessage.includes('Network Error') ||
      errorMessage.includes('ERR_CONNECTION_CLOSED'))
  );
};

class AuthServiceClass {
  register = async (affiliateId, influencerId) => {
    try {
      const body = {};
      if (affiliateId) {
        body.affiliateId = affiliateId;
      }
      if (influencerId) {
        body.influencerId = influencerId;
      }
      const response = await axiosApiClient.post(`${BASE_URL}/register`, body);
      throwErrorIfWrongStatus(response, 200);
      const { referredBy: referredByUser } = response.data.data;
      return { referredByUser };
    } catch (err) {
      throw handleError(err, 'Error occurred while registering user');
    }
  };

  getUserInfo = async affiliateId => {
    let lastError;

    for (let retryAttempt = 0; retryAttempt <= GET_USER_INFO_RETRY_COUNT; retryAttempt += 1) {
      try {
        const response = await axiosApiClient.post(`${BASE_URL}/me`, { ...(affiliateId && { affiliateId }) });
        throwErrorIfWrongStatus(response, 200);
        const { user } = response.data.data;
        return { user };
      } catch (err) {
        lastError = err;

        if (!isRetryableConnectionError(err) || retryAttempt === GET_USER_INFO_RETRY_COUNT) {
          throw handleError(err, 'Error occurred while getting user');
        }

        await wait(GET_USER_INFO_RETRY_DELAYS_MS[retryAttempt]);
      }
    }

    throw handleError(lastError, 'Error occurred while getting user');
  };
}

const AuthService = new AuthServiceClass();
export default AuthService;
